import { action, computed, makeObservable, observable } from 'mobx';
import { inject, observer } from 'mobx-react';
import ErrorUtil from '@/util/ErrorUtil';
import ReactComponent from '../../ReactComponent';
import PainelDecisaoSessao from './PainelDecisaoSessao';
import PainelDecisaoPreSessao from './PainelDecisaoPreSessao';

class PainelDecisao extends ReactComponent {
    mostrarEmentaDecisao = 'ementa';

    constructor(props) {
        super(props);

        makeObservable(this, {
            mostrarEmentaDecisao: observable,
            registro: computed
        });
    }

    async componentDidMount() {
        try {
            await this.salaSessaoStore.carregarTranscendenciaBloqueioBaixa(this.registro);
        } catch (error) {
            console.error(`Falha na inicialização do componente PainelDecisao: ${ErrorUtil.getMensagemErro(error)}`);
            throw new Error('Falha na inicialização do componente PainelDecisao', { cause: error });
        }
    }

    componentDidUpdate = async (prevProps) => {
        super.componentDidUpdate(prevProps);
        await this.salaSessaoStore.carregarTranscendenciaBloqueioBaixa(this.registro);
    };

    get registro() {
        return this.observableProps.registro;
    }

    render() {
        return this.isPreSessao ? (
            <PainelDecisaoPreSessao registro={this.registro} />
        ) : (
            <PainelDecisaoSessao registro={this.registro} />
        );
    }
}

export default inject('stores')(observer(PainelDecisao));
